
import firebase from 'firebase'
import * as firebaseui from 'firebaseui'
import Vue from 'vue'
import log from './log.js';

export default {
    init() {
        return new Promise((resolve, reject) => {
            Vue.prototype.$firebaseui = firebaseui;
            Vue.prototype.$authUI = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(firebase.auth());
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    //alert('サインインしました。' + user.displayName);
                    
                    log.methods.log(user);
                    // User is signed in.
                    var displayName = user.displayName;
                    var email = user.email;
                    var emailVerified = user.emailVerified;
                    var photoURL = user.photoURL;
                    var uid = user.uid;
                    var phoneNumber = user.phoneNumber;
                    var providerData = user.providerData;
                    user.getIdToken().then(function(accessToken) {
                    
                    });
                } else {
                    // User is signed out.
                    //alert('サインアウトしました。');
                }
                resolve(user);
            }, function(error) {
                log.methods.log(error);
                reject(error);
            });    
        });
    },
    signOut() {
        // console.log('main', global.rootVue)
        return global.rootVue.$firebase.auth().signOut().then(()=>{
            // サインアウト
            // 画面遷移
            global.rootVue.$delete(global.rootVue.$profile, 'user');
            global.rootVue.$router.push({ path: '/' })
            // console.log('singOut')
            // window.location.reload()
        }).catch((error) => {
            // エラー
            console.error('サインアウト時にエラーがが発生しました。', error)
        });
    }
}
